import { render, staticRenderFns } from "./fahuolist_expand.vue?vue&type=template&id=3cb197ce&scoped=true"
import script from "./fahuolist_expand.vue?vue&type=script&lang=js"
export * from "./fahuolist_expand.vue?vue&type=script&lang=js"
import style0 from "./fahuolist_expand.vue?vue&type=style&index=0&id=3cb197ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb197ce",
  null
  
)

export default component.exports